import { Flex, Space } from "antd";
import styles from "./index.module.less";
import p2Icon1 from "./imgs/p2_icon1.png";
import p2Icon2 from "./imgs/p2_icon2.png";
import p2Icon3 from "./imgs/p2_icon3.png";
import p2Icon4 from "./imgs/p2_icon4.png";
import classNames from "classnames";
import P1Content from "@/components/P1Content";
import data from "../data";
import banner from "./imgs/p1_bg.png";

// 图标映射
const iconMap: Record<string, string> = {
  p2Icon1,
  p2Icon2,
  p2Icon3,
  p2Icon4,
};

const P2Card = ({
  title,
  list,
  icon,
  right = false,
  index = 1,
}: {
  title: string;
  list: { label?: string; desc: string }[];
  icon: keyof typeof iconMap;
  right?: boolean;
  index?: number;
}) => {
  return (
    <Flex
      vertical
      gap={".12rem"}
      className={classNames(styles.p2_card, right && styles.p2_card_right)}
    >
      <div className={styles.p2_card_index}>
        {index < 10 ? `0${index}` : index}
      </div>
      <Flex gap={".04rem"} align="center" className={styles.p2_card_title}>
        <img src={iconMap[icon]} />
        {title}
      </Flex>
      <ul className={styles.p2_card_list}>
        {list.map((item, index) => (
          <li key={index} className={styles.p2_card_item}>
            <span className={styles.p2_card_list_label}>{item.label}</span>
            <span className={styles.p2_card_list_desc}>{item.desc}</span>
          </li>
        ))}
      </ul>
    </Flex>
  );
};
const P3Card = ({
  title,
  tags,
  img,
  desc,
  index,
}: {
  title: string;
  tags: string[];
  img?: string;
  desc?: string;
  index: number;
}) => {
  return (
    <Flex className={styles.p3_card}>
      <div className={styles.p3_card_img}>
        <img src={img} alt={title} />
      </div>
      <div className={styles.p3_card_content}>
        <Flex
          align="center"
          justify="space-between"
          className={styles.p3_card_header}
        >
          <div className={styles.p3_card_title}>{title}</div>
          <div className={styles.p3_card_index}>0{index + 1}</div>
        </Flex>

        <div className={styles.p3_card_tags}>
          <Space size={8}>
            {tags.map((tag, index) => (
              <div key={index} className={styles.p3_card_tag}>
                {tag}
              </div>
            ))}
          </Space>
        </div>
        <div className={styles.p3_card_desc}>{desc}</div>
      </div>
    </Flex>
  );
};
const MobileMachine = () => {
  return (
    <div>
      <div className={styles.p1}>
        <P1Content
          title={data.p1.title}
          subtitle={data.p1.subtitle}
          link={data.p1.link}
          style={{
            backgroundImage: `url(${banner})`,
          }}
        />
      </div>
      <div className={styles.p2}>
        <div className={styles.p2_inner}>
          <div className={styles.p2_title}>{data.p2.title}</div>
          <Flex justify="space-between" className={styles.p2_content}>
            <Flex gap={".2rem"} vertical>
              {data.p2.list[0].map((item, itemIndex) => (
                <P2Card key={itemIndex} {...item} icon={item.icon} />
              ))}
            </Flex>
            <Flex gap={".2rem"} vertical>
              {data.p2.list[1].map((item, itemIndex) => (
                <P2Card key={itemIndex} {...item} icon={item.icon} right />
              ))}
            </Flex>
          </Flex>
        </div>
      </div>
      <div className={styles.p3}>
        <div className={styles.p3_inner}>
          <div className={styles.p3_title}>{data.p3.title}</div>
          <div className={styles.p3_content}>
            {data.p3.list.map((item, index) => (
              <P3Card {...item} key={index} index={index} />
            ))}
          </div>
        </div>
      </div>
    </div>
  );
};
export default MobileMachine;
